export default __webpack_public_path__ + "static/media/Null-24.cf7f18b4.svg";